/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  InvalidateQueryFilters,
  QueryClient,
  useQuery,
  UseQueryResult,
  useSuspenseQuery,
  UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { GramError } from "../models/errors/gramerror.js";
import {
  ConnectionError,
  InvalidRequestError,
  RequestAbortedError,
  RequestTimeoutError,
  UnexpectedClientError,
} from "../models/errors/httpclienterrors.js";
import { ResponseValidationError } from "../models/errors/responsevalidationerror.js";
import { SDKValidationError } from "../models/errors/sdkvalidationerror.js";
import { ServiceError } from "../models/errors/serviceerror.js";
import {
  GetAgentRequest,
  GetAgentSecurity,
} from "../models/operations/getagent.js";
import { useGramContext } from "./_context.js";
import {
  QueryHookOptions,
  SuspenseQueryHookOptions,
  TupleToPrefixes,
} from "./_types.js";
import {
  AgentQueryData,
  buildAgentQuery,
  prefetchAgent,
  queryKeyAgent,
} from "./agent.core.js";
export { type AgentQueryData, buildAgentQuery, prefetchAgent, queryKeyAgent };

export type AgentQueryError =
  | ServiceError
  | GramError
  | ResponseValidationError
  | ConnectionError
  | RequestAbortedError
  | RequestTimeoutError
  | InvalidRequestError
  | UnexpectedClientError
  | SDKValidationError;

/**
 * get agents
 */
export function useAgent(
  request: GetAgentRequest,
  security?: GetAgentSecurity | undefined,
  options?: QueryHookOptions<AgentQueryData, AgentQueryError>,
): UseQueryResult<AgentQueryData, AgentQueryError> {
  const client = useGramContext();
  return useQuery({
    ...buildAgentQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

/**
 * get agents
 */
export function useAgentSuspense(
  request: GetAgentRequest,
  security?: GetAgentSecurity | undefined,
  options?: SuspenseQueryHookOptions<AgentQueryData, AgentQueryError>,
): UseSuspenseQueryResult<AgentQueryData, AgentQueryError> {
  const client = useGramContext();
  return useSuspenseQuery({
    ...buildAgentQuery(
      client,
      request,
      security,
      options,
    ),
    ...options,
  });
}

export function setAgentData(
  client: QueryClient,
  queryKeyBase: [parameters: { id: string; gramSession?: string | undefined }],
  data: AgentQueryData,
): AgentQueryData | undefined {
  const key = queryKeyAgent(...queryKeyBase);

  return client.setQueryData<AgentQueryData>(key, data);
}

export function invalidateAgent(
  client: QueryClient,
  queryKeyBase: TupleToPrefixes<
    [parameters: { id: string; gramSession?: string | undefined }]
  >,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "agents", "get", ...queryKeyBase],
  });
}

export function invalidateAllAgent(
  client: QueryClient,
  filters?: Omit<InvalidateQueryFilters, "queryKey" | "predicate" | "exact">,
): Promise<void> {
  return client.invalidateQueries({
    ...filters,
    queryKey: ["@gram/client", "agents", "get"],
  });
}
